import { BasketDetails } from 'shared-types/Basket';

type MoneyValue = { amount: number; currencyCode: string };

export type BasketSummaryTotals = {
  subtotal?: MoneyValue;
  specialOffersDiscount?: MoneyValue;
  promotionsDiscount?: MoneyValue;
  vouchersDiscount?: MoneyValue;
};

type BasketLike = Pick<BasketDetails, 'discountTotals' | 'activePromo' | 'vouchers'>;

const positive = (amount: number, currencyCode: string): MoneyValue | undefined =>
  amount > 0 ? { amount, currencyCode } : undefined;

export const buildBasketSummaryTotals = (
  basket: BasketLike | undefined | null
): BasketSummaryTotals => {
  const standardTotal = basket?.discountTotals?.standardTotal;
  const discountedTotal = basket?.discountTotals?.discountedTotal;
  const currencyCode = standardTotal?.currencyCode ?? '';

  const promo = basket?.activePromo;
  let promotionsDiscount: MoneyValue | undefined;
  if (promo) {
    if (promo.discountValue.type === 'price') {
      const { amount, currencyCode: promoCurrency } = promo.discountValue.value;
      promotionsDiscount = positive(amount, promoCurrency);
    } else if (standardTotal) {
      promotionsDiscount = positive(
        Math.round((standardTotal.amount * promo.discountValue.value) / 100),
        currencyCode
      );
    }
  }

  const vouchers = Array.isArray(basket?.vouchers) ? basket.vouchers : [];
  const vouchersAmount = vouchers.reduce((sum, v) => sum + (v.redemptionTotal?.amount ?? 0), 0);
  const vouchersDiscount =
    vouchersAmount > 0
      ? positive(vouchersAmount, vouchers[0]?.redemptionTotal?.currencyCode ?? currencyCode)
      : undefined;

  const totalSaving =
    standardTotal && discountedTotal ? standardTotal.amount - discountedTotal.amount : 0;
  const specialOffersDiscount = positive(
    totalSaving - (promotionsDiscount?.amount ?? 0) - (vouchersDiscount?.amount ?? 0),
    currencyCode
  );

  return {
    subtotal: standardTotal ? { amount: standardTotal.amount, currencyCode } : undefined,
    specialOffersDiscount,
    promotionsDiscount,
    vouchersDiscount,
  };
};
